<template lang="pug">
.v-promo-options.promo-options(v-if="data" :id="data?.id")
	.promo-options__title(v-if="data.title") {{data.title}}
	.promo-options__items(v-if="data.items")
		.promo-options__item(v-for="(item, idx) in data.items" :key="idx" :style="{backgroundColor: item.backgroundColor}")
			img.promo-options__item-image(v-if="item.image" :src="item.image.src" :alt="item.image.alt")
			.promo-options__item-title(v-if="item.title" :style="{color: item.title.color}") {{item.title.text}}
			.promo-options__item-text(v-if="item.text" :style="{color: item.text.color}") {{item.text.text}}
			.promo-options__actions(v-if="item.actions")
				v-action(v-for="(action, idxAct) in item.actions" :key="idxAct" :action="action")
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>